/**
 * Base URL ของ External API — คำนวณจาก hostname ปัจจุบัน
 * localhost → REACT_APP_API_URL (dev), production → api.<root-domain>
 */
export type ApiVersion = 'v1' | 'v2';

export const getBaseUrl = (version: ApiVersion = 'v1'): string => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    const base = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';
    return base.replace('/api/v1', `/api/${version}`);
  }
  const parts = hostname.split('.');
  const baseDomain = parts.length >= 2 ? parts.slice(-2).join('.') : hostname;
  return `${protocol}//api.${baseDomain}/api/${version}`;
};
